export const DROPDOWN_OPTIONS_ENDPOINTS = {
    parkingStatuses: '/v3/auth/parking-statuses/dropdown',
    deliveryMethods: '/v3/auth/delivery-methods/dropdown',
} as const;
